<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_stretch">
            <div class="fx fx-center">
                <span>页面标题：</span>
                <el-input v-model="page.name" style="width: 200px"></el-input>
                <span style="margin-left:10px">选择模板：</span>
                <el-select v-model="page.formworkId" clearable placeholder="请选择模板" :disabled="tableData.length > 0">
                    <el-option
                        v-for="item in formworks"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <span style="margin-left:10px">选择类型：</span>
                <!-- :disabled="tableData.length > 0" -->
                <el-select v-model="page.type" clearable placeholder="请选择类型" >
                    <el-option
                        v-for="item in websitePageTypes"
                        :key="item.optionValue"
                        :label="item.optionText"
                        :value="item.optionValue">
                    </el-option>
                </el-select>
            </div>
            <div class="fx fx-center">
                <el-button type="primary" @click="editCustom({content: ''})">自定义模块添加</el-button>
                <el-button type="primary" @click="addModule()">内置模块添加</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    min-width="800"
                    label="模块预览" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 1" class="fx fx-center" >
                            <img :src="scope.row.coverImg" style="width: 800px;height: auto">
                        </div>
                        <div v-if="scope.row.type ==2" class="fx fx-center">
                            <div  v-html="scope.row.content" class="page_module-content"></div>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    min-width="180"
                    label="模块数据" >
                    <template slot-scope="scope">
                        <div  class="fx fx-center" v-for="(item, i) in scope.row.list" :key="i">
                            {{item.flag}}:{{item.name}}
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column
                    min-width="180"
                    label="顺序调整" >
                    <template slot-scope="scope">
                        <i class="el-icon-arrow-up font20 order_btn" @click="up(scope.$index)"></i>
                        <i class="el-icon-arrow-down font20 order_btn" @click="down(scope.$index)"></i>

                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">  
                        <el-link  v-if="scope.row.type == 2" @click="editCustom(scope.row)"
                                  type="primary" :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-link  @click="editDesignData(scope.row,scope.$index)" v-if="scope.row.uploadNum>0"
                                  type="primary" :underline="false" ><i class="iconfont icon-bianji"></i><b>设计数据</b></el-link>    
                        <el-popconfirm @onConfirm="del(scope.$index)"
                                       title="确认删除模块吗？" >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-button type="primary" @click="sub">保存</el-button>
            <el-button @click="closeCurrentTab" >关闭</el-button>
        </div>

        <ModuleLibPage v-if="showLib" @submit="addLibModule" :item="page.formworkId" @close="showLib=false"></ModuleLibPage>

        <CustomModuleDrawer v-if="showCustom" :item="currentCustom"
                            @close="showCustom = false" @submit="addCustomModule"></CustomModuleDrawer>
        <DesignDataEditDrawer v-if="showDesignData" :item="designData"
                            @close="showDesignData = false" @submit="addDesignData"></DesignDataEditDrawer>
    </div>
</template>

<style scoped>
    .order_btn {
        display: inline-block;
        background: var(--primary);
        color: white;
        margin: 0 5px;
        cursor: pointer;
        padding: 2px;
    }
    .page_module-content {
        width: 800px;
        text-align: left;
    }

</style>
<style>

    .page_module-content img{
        max-width: 100%;
    }
</style>

<script>
    import ModuleLibPage from "./ModuleLibPage";
    import CustomModuleDrawer from "./CustomModuleDrawer";
    import {mapState, mapMutations} from "vuex";
    import DesignDataEditDrawer from "./DesignDataEditDrawer";

    export default {
        components: {
            ModuleLibPage,
            CustomModuleDrawer,
            DesignDataEditDrawer
        },
        props: [
            "attr"
        ],
        data() {
            return {
                page: {...this.attr.page},
                showLib: false,
                showCustom: false,
                currentCustom: {},
                tableData: [],
                formworks: [],
                //formworkId:'',
                showDesignData: false,
                designData: [],
                indexFlag:'',
                websitePageTypes:[],
            }

        },

        computed: {
            ...mapState({})
        },

        methods: {
            ...mapMutations(["closeCurrentTab"]),
            addLibModule(modules) {
                if (modules && modules.length > 0) {
                    this.tableData.push(...modules);
                    this.showLib = false;
                }
            },
            addCustomModule(module) {
                if (module.id) {
                    this.tableData.forEach(item => {
                        if (item.id == module.id) {
                            item.content = module.content;
                        }
                    })
                } else {
                    this.tableData.push(module);
                }
                this.showCustom = false;
            },
            addDesignData(design){
                if(design){
                    this.tableData[this.indexFlag].list = design;
                    this.showDesignData = false;
                }
            },
            addModule() {
                if(!this.page.formworkId){
                    this.$showError("请选择模板后再添加内置模块");
                    return ;
                }
                this.showLib = true;
            },
            sub() {
               if (this.tableData.length == 0) {
                   this.$showError("请添加模块后再保存");
                   return;
               }
               if (!this.page.name) {
                   this.$showError("请输入页面标题再保存");
                   return;
               }
               if (this.tableData.length > 20) {
                   this.$showError("单页面模块数量不能超过20个");
                   return;
               }

               this.tableData.forEach((item ,i) => {
                   item.rank = i;
               })

               this.$ajaxPost("/websitePage/save", {
                   websitePage: this.page,
                   modules: this.tableData
               }, data => {
                   this.$showSuccess("保存成功", 1200, ()=> {
                       this.attr.refreshParent();
                       this.closeCurrentTab();
                   })
               })

            },
            del(index) {
                this.tableData.splice(index,  1);
            },

            loadData() {
                if (this.page.id) {
                    this.$ajaxGet("/pageModule/list/" + this.page.id, data => {
                        this.tableData = data.result;
                    })
                }
            },

            editCustom(item) {
                this.currentCustom = {...item};
                this.showCustom = true;

            },
            editDesignData(item,index) {
                console.log(item)
                this.designData = item;
                this.indexFlag = index;
                this.showDesignData = true;
            },
            up(index) {
                if (index == 0) return;
                let item = this.tableData.splice(index, 1);
                this.tableData.splice(index - 1, 0, ...item);
            },
            down(index) {
                if (index == (this.tableData.length - 1)) return;
                let item = this.tableData.splice(index, 1);
                this.tableData.splice(index + 1, 0, ...item);
            },
            loadFormworks() {
                this.$ajaxGet("/formwork/listOption", (data) => {
                    this.formworks = data.result;
                })
            },
            loadWebSitePageTypes() {
                this.$ajaxGet("/websitePage/websitePageType", (data) => {
                    this.websitePageTypes = data.result;
                })
            }
        },

        created() {
            this.loadData();
            this.loadFormworks();
            this.loadWebSitePageTypes();
        }

    }
</script>
